import { z } from 'zod';
export var BaseAccountPersonaDetails = z.object({
    persona_name: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    job_function: z.string().nullish(),
    job_level: z.string().nullish(),
    job_title: z.string().nullish(),
});
export var AccountPersonaDetails = BaseAccountPersonaDetails.extend({
    has_business_email: z.boolean().nullish(),
    has_direct_number: z.boolean().nullish(),
    has_mobile_phone: z.boolean().nullish(),
    has_linkedin_url: z.boolean().nullish(),
});
export var AccountPersonaExpandedDetails = AccountPersonaDetails.extend({
    business_email: z.string().nullish(),
    direct_number: z.string().nullish(),
    mobile_phone: z.string().nullish(),
    linkedin_url: z.string().nullish(),
});
export var BuyingGroupInsight = z.object({
    active_domains_count: z.number(),
    active_accounts_with_contacts: z.number(),
    total_contacts: z.number(),
    details: z.object({
        total_personas: z.number().nullish(),
        matching_personas_list: z.array(z.string().nullish()).default([]),
    }),
    coverage: z.number().nullish(),
    count_distribution: z.array(z.object({
        number_of_contacts_per_account: z.number().nullish(),
        contacts_per_account_count: z.number().nullish(),
    })),
    job_level_distribution: z
        .array(z.object({
        job_level: z.string().nullish(),
        contacts_per_job_level: z.number().nullish(),
    }))
        .default([]),
    job_function_distribution: z
        .array(z.object({
        job_function: z.string().nullish(),
        contacts_per_job_function: z.number().nullish(),
    }))
        .default([]),
    interest_level_distribution: z.array(z.object({
        interest_level: z.enum(['Low', 'Medium', 'High']),
        accounts_per_interest_level: z.number(),
    })),
    active_accounts_with_intent: z.number(),
    contacts_by_persona: z.array(z.object({
        persona_name: z.string(),
        contacts_per_persona: z.number(),
    })),
});
export var BuyingGroupInsightRawObject = z.object({
    ad_cnt: z.number().default(0),
    act_acc_cont: z.number().default(0),
    total_cont: z.number().default(0),
    details: z.object({
        tp: z.number().nullish(),
        list: z.array(z.string().nullish()).default([]),
    }),
    coverage: z.number().nullish(),
    cnt_dist: z
        .array(z.object({
        nmb_cont_per_acc: z.number().nullish(),
        cont_per_acc_cnt: z.number().nullish(),
    }))
        .default([]),
    jl_dist: z
        .array(z.object({
        jl: z.string().nullish(),
        cont_per_jl: z.number().nullish(),
    }))
        .default([]),
    jf_dist: z
        .array(z.object({
        jf: z.string().nullish(),
        cont_per_jf: z.number().nullish(),
    }))
        .default([]),
    inter_lvl_dist: z
        .array(z.object({
        lvl: z.enum(['Low', 'Medium', 'High']),
        cnt: z.number(),
    }))
        .default([]),
    int_act_acc: z.number(),
    cont_by_pers: z
        .array(z.object({
        pn: z.string(),
        cnt: z.number(),
    }))
        .default([]),
});
export var TopPersonaWithIntent = z.object({
    personaName: z.string(),
    jobFunction: z.string(),
    jobLevel: z.string(),
    topTopics: z.array(z.string()),
    bgInterest: z.enum(['Low', 'Medium', 'High']),
});
export var BuyingGroupWebVisits = z.object({
    score7: z.number(),
    score30: z.number(),
    score60: z.number(),
    scoreTotal: z.number(),
});
//# sourceMappingURL=BuyingGroup.js.map